import * as Yup from 'yup';

export const INITIAL_VALUES = {
  name: '',
};

export const FORM_VALIDATION_SCHEMA = Yup.object().shape({
  name: Yup.string().required('Name is required'),
});
